
import styled from 'styled-components/macro'
import Button from '../button/button'
import { useTranslation } from 'react-i18next';
import SliderWithInput from '../slider-with-input/slider-with-input';
import { useEffect, useState } from 'react';

const Wrapper = styled.div`
  background: rgba(234, 226, 218, 0.55);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 55px;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 1200px) {
    flex-direction: column;
    border-radius: 0;
    font-size: 10px;
    gap: 0px;
    padding: 14px 16px;
    margin: 0 -20px;
  }
`

const ButtonsBlock = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: flex-start;
  gap: 9px;

  @media (max-width: 1200px) {
    margin-bottom: 14px;
  }
`

const SlidersBlock = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: flex-start;
  gap: 9px;
  @media (max-width: 1200px) {
    display: flex;
    align-items: space-between;
    justify-content: center;
    gap: 15px;
    margin-bottom: 14px;
  }
`


const Filters = ({ onSubmit, currentFIlter }) => {
  const [filter, setFilter] = useState(currentFIlter)
  const {t} = useTranslation();

  const isChanged = filter.status !== currentFIlter.status
    || filter.size !== currentFIlter.size
    || filter.price !== currentFIlter.price

  const changeFilterHandler = (field) => (value) => {
    setFilter((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  const submitHandler = () => {
    onSubmit(filter)
  }
  
  useEffect(() => {
    setFilter(currentFIlter);
  }, [currentFIlter])

  return (
      <Wrapper>
        <ButtonsBlock>
            <Button onClick={() => changeFilterHandler('status')(null)} active={filter.status === null}>{t('all')}</Button>
            <Button onClick={() => changeFilterHandler('status')('3')} active={filter.status === '3'}>{t('reserved')}</Button>
            <Button onClick={() => changeFilterHandler('status')('2')} active={filter.status === '2'}>{t('soldOut')}</Button>
            <Button onClick={() => changeFilterHandler('status')('1')} active={filter.status === '1'}>{t('forSale')}</Button>
        </ButtonsBlock>
        <SlidersBlock>
            <SliderWithInput label={t('price')} min={0} max={10000} step={5} onChange={changeFilterHandler('price')} />
            <SliderWithInput label={t('size')} min={0} max={100} step={5} onChange={changeFilterHandler('size')} />    
        </SlidersBlock>
        <Button onClick={submitHandler} disabled={!isChanged}>{t('apply')}</Button>
      </Wrapper>
  )
}

export default Filters